import { SITE_ROUTES } from "@/config/siteRoutes";
import { CmsManagedPage } from "@/pages/EditorialPages/CmsManagedPage";
import type { CmsContentPageData } from "@/pages/shared/cmsContent";

const fallback: CmsContentPageData = {
  id: 6,
  slug: "our-vision",
  title: "Our Vision",
  intro:
    "The long-term shift into a clearer, more elegant and more influential creative business built around events, branding and digital presence.",
  seoTitle: "Our Vision",
  searchDescription:
    "VenueX vision for events as strategic communication, with technology, continuity and authored presence moving together.",
  url: SITE_ROUTES.vision,
  bodyHtml: "",
  sections: [],
  paragraphs: [
    {
      html: "<p>We want to redefine how corporate events, conferences and exhibitions are experienced: as clearer, more elegant and more influential expressions of the brand behind them.</p>",
      text: "We want to redefine how corporate events, conferences and exhibitions are experienced: as clearer, more elegant and more influential expressions of the brand behind them.",
    },
    {
      html: "<p>The ambition is not more noise. It is more substance, more memory and more control carried with discretion across every touchpoint.</p>",
      text: "The ambition is not more noise. It is more substance, more memory and more control carried with discretion across every touchpoint.",
    },
    {
      html: "<p>That means strategic thinking, visual taste and digital continuity should all be felt inside the same experience, rather than being treated as unrelated departments.</p>",
      text: "That means strategic thinking, visual taste and digital continuity should all be felt inside the same experience, rather than being treated as unrelated departments.",
    },
    {
      html: "<p>The future standard should already be visible in the pages, the services and the way VenueX is introduced to each new client.</p>",
      text: "The future standard should already be visible in the pages, the services and the way VenueX is introduced to each new client.",
    },
  ],
};

export function OurVisionPage() {
  return (
    <CmsManagedPage
      slug="our-vision"
      currentPath={SITE_ROUTES.vision}
      eyebrow="Editorial horizon"
      visualImage="/static/venuex/live/story-experience.jpg"
      visualAlt="VenueX future vision translated into premium presence"
      leadTitle="What the future standard should feel like"
      leadCopy="The vision page should project the direction of the brand with clarity, discipline and enough ambition to support the whole VenueX experience."
      routeLinks={[
        { href: SITE_ROUTES.servicesArchive, label: "See the service architecture", meta: "Capabilities" },
        { href: SITE_ROUTES.portfolio, label: "Review selected work", meta: "Portfolio" },
        { href: SITE_ROUTES.contact, label: "Start a tailored brief", meta: "Direct contact" },
      ]}
      primaryCtaLabel="View portfolio"
      primaryCtaHref={SITE_ROUTES.portfolio}
      secondaryCtaLabel="Explore services"
      secondaryCtaHref={SITE_ROUTES.servicesArchive}
      fallback={fallback}
    />
  );
}
